import { parseTriggerForDisplay } from 'components/schedules/trigger-utils'

export function getNextScheduled(trigger) {
  const next = parseTriggerForDisplay(trigger)
  const scheduled =
    trigger.type === 'Random' ? `${next.start} to ${next.end}` : next.time
  return `Scheduled: ${scheduled}`
}

// this is not really a theming value, but it's a somewhat arbitrary/magic value
// that can be provided for left padding MUI ListItems so that they line up with the section header
export const NOTIFICATION_LEFT_PADDING = 7
